/**
 * ProductAuditListContainer
 * --
 */
import { useState, useEffect } from 'react';
import ProductAuditListPresenter from './ProductAuditListPresenter';
import MessageAlert from 'utils';
import { ShopInformationApi, ProductApi } from 'api';
import {
  PRODUCT_TYPE,
  PRODUCT_STATUS,
  APPLICATION_STATUS,
} from 'constants/ProductConstants';
const DEFAULT_SEARCH_VALUE = {
  product_name: null,
  shop_information_name: null,
};
/**----------------------------------------
 * [Component] 입점업체 상세: 컨테이너
 * ----------------------------------------
 */
const ProductAuditListContainer = ({
  defaultShopId,
  onChangeShopInformation,
  permission,
  productAuditMode,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [shopId, setShopId] = useState(defaultShopId);
  const [productList, setProductList] = useState([]);
  const [searchValue, setSearchValue] = useState(DEFAULT_SEARCH_VALUE);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */

  /**--------------------
   * 상품(product) 데이터 변경
   * --------------------
   */
  const handleChangeProduct = async (product_id, key, newStatus) => {
    if (permission !== 'ADMIN') {
      return;
    }
    setLoading(true);
    try {
      if (!newStatus) {
        MessageAlert.warning('값을 입력해주세요');
        setLoading(false);
        return;
      }
      const fid = productList.findIndex((p) => p.product_id === product_id);
      const newData = {
        product_id,
        [key]: newStatus,
      };

      // API Call
      const { status, message } = await ProductApi.updateProduct(newData);
      // 예외처리
      if (status !== 200) throw { message };

      setTimeout(() => {
        MessageAlert.info('변경되었습니다.');
        setLoading(false);
        setProductList((prev) => [
          ...prev.slice(0, fid),
          {
            ...prev[fid],
            ...newData,
          },
          ...prev.slice(fid + 1),
        ]);
      }, 1000);
    } catch (e) {
      setLoading(false);
      console.log('[BrandDetailContainer][handleChangeProduct] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /**
   *
   * @param {string} t
   * @param {string | number} v
   */
  const handleChange = (t, v) => {
    setSearchValue((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  /* ===== HOOKS ===== */

  /**--------------------
   * 입점업체 상품 조회
   * --------------------
   */
  useEffect(() => {
    const call = async () => {
      try {
        const { status, message, data } = await ProductApi.getProducts({
          join_tables: `["shop_information"]`,
          ...(defaultShopId && { shop_information_id: defaultShopId }),
        });
        if (status !== 200) throw { message };
        setProductList(data);
      } catch (e) {
        MessageAlert.error(e.message);
      }
    };

    call();
  }, []);

  /* ===== RENDER ===== */
  return (
    <>
      <ProductAuditListPresenter
        {...{
          loading,
          shopId,
          permission,
          productList,
          onChangeProduct: handleChangeProduct,
          searchValue,
          onChange: handleChange,
        }}
      />
    </>
  );
};

/* Default props */
ProductAuditListContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
  productAuditMode: false,
  onChangeShopInformation: () => {},
};
export default ProductAuditListContainer;
